export default __webpack_public_path__ + "static/media/Family Members-03.576c3d7c.svg";